import { createSelector } from 'reselect'

export const scopeDropdownSelector = (state) => state.home_bar.scope_dropdown

export const titleSelector = createSelector(
  scopeDropdownSelector,
  ({ title }) => title
)

export const dataSelector = createSelector(
  scopeDropdownSelector,
  ({ data }) => data
)

export const filterTermSelector = createSelector(
  scopeDropdownSelector,
  ({ filterTerm }) => filterTerm
)

export const forceExpandTriggeredSelector = createSelector(
  scopeDropdownSelector,
  ({ forceExpandTriggered }) => forceExpandTriggered
)

export const policySelector = createSelector(
  dataSelector,
  (data) => data.policy
)

export const usersSelector = createSelector(
  dataSelector,
  (data) => (data ? data.users.data : [])
)

export const teamsSelector = createSelector(
  dataSelector,
  (data) => (data ? data.pages.data : [])
)

export const userGroupsWhereAdminSelector = createSelector(
  dataSelector,
  (data) => (data ? data.user_groups.data : [])
)

export const isFilteringSelector = createSelector(
  filterTermSelector,
  (filterTerm) => Boolean(filterTerm && filterTerm.length > 0)
)

export const isDataPresentSelector = createSelector(
  isFilteringSelector,
  usersSelector,
  teamsSelector,
  userGroupsWhereAdminSelector,
  (isFiltering, users, teams, groups) => {
    if (!isFiltering) return true
    return users.length + teams.length + groups.length > 0
  }
)

export const hasMoreUsersSelector = createSelector(
  dataSelector,
  (data) => data && !!data.users.next_page
)

export const hasMoreTeamsSelector = createSelector(
  dataSelector,
  (data) => data && !!data.pages.next_page
)

export const hasMoreUserGroupsSelector = createSelector(
  dataSelector,
  (data) => data && !!data.user_groups.next_page
)

export const hasAnyUserGroupsSelector = createSelector(
  scopeDropdownSelector,
  ({ anyUserGroups }) => anyUserGroups || false
)
